import { render, staticRenderFns } from "./CourseInfoInformation.vue?vue&type=template&id=acca2ac6&"
import script from "./CourseInfoInformation.vue?vue&type=script&lang=js&"
export * from "./CourseInfoInformation.vue?vue&type=script&lang=js&"
import style0 from "./CourseInfoInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports